// extracted by mini-css-extract-plugin
module.exports = {"joinMindTrustLayout":"JoinMindTrustLayout_joinMindTrustLayout__1of_9","logo":"JoinMindTrustLayout_logo__1-iGG","content":"JoinMindTrustLayout_content__2YJ-h"};